import { useLayoutEffect, useRef } from "react";
import { Link } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { PRODUCTS } from "@/data/content";
import ProductCard from "@/components/ProductCard";

gsap.registerPlugin(ScrollTrigger);

export default function ProductsSection() {
  const root = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      gsap.from("[data-product-grid] > *", {
        y: 60,
        opacity: 0,
        duration: 0.9,
        stagger: 0.12,
        ease: "power3.out",
        scrollTrigger: { trigger: "[data-product-grid]", start: "top 80%" },
      });
    }, root);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={root} id="tuotteet" data-testid="products-section" className="py-24 md:py-36">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <p className="eyebrow text-water-deep/80">Tuotteet</p>
            <h2 className="h-section font-heading mt-5 font-semibold text-foreground" lang="fi">
              Valitse omasi.
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-muted-foreground">
            Kaikki hinnat sisältävät ALV:n. Toimituskulut lisätään kassalla.
          </p>
        </div>
        <div data-product-grid className="mt-12 md:mt-16 grid gap-7 md:grid-cols-2 lg:grid-cols-3">
          {PRODUCTS.slice(0, 3).map((p) => (
            <ProductCard key={p.slug} product={p} />
          ))}
        </div>
        <p className="mt-8 text-sm text-muted-foreground">
          Etsitkö pakettitarjouksia?{" "}
          <Link to="/kauppa/" className="font-bold text-primary transition-colors hover:text-water-deep" data-testid="products-shop-link">
            Kaupasta löydät myös säästöpaketit →
          </Link>
        </p>
      </div>
    </section>
  );
}
